import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 4.08333C2.5 3.20888 3.20888 2.5 4.08333 2.5H25.9167C26.7911 2.5 27.5 3.20888 27.5 4.08333V25.9167C27.5 26.7911 26.7911 27.5 25.9167 27.5H4.08333C3.20888 27.5 2.5 26.7911 2.5 25.9167V4.08333Z",
      stroke: "currentColor",
      "stroke-width": "1.58333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 20H16.5123V18.3227H12.0565V11.1055H10V20Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.5119 12.2109C19.2482 12.2109 19.7433 11.7281 19.7433 11.0673C19.7433 10.4574 19.2482 10 18.5119 10C17.7756 10 17.2805 10.4828 17.2805 11.1055C17.2805 11.7281 17.7756 12.2109 18.5119 12.2109ZM17.5217 20H19.5021V13.1639H17.5217V20Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }